import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirmDialog.html',
    styleUrls: ['./confirmDialog.scss']
})
export class ConfirmDialog {

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { message: string }
    ) { }

    onConfirm(): void {
        console.log('confirm');
        this.dialogRef.close(true);
    }

    onCancel(): void {
        console.log('cancel');
        this.dialogRef.close(false);
    }
}